import React, {  } from 'react';
import Select from 'react-select';
import ModulosView from './Cursos/ModulosView';

const CourseSelector = ({
	dataCursos,
	dataModulosInicio,
	handleCursoChange,
	customStyles
}) => {

	return (
		<div className="body rounded mb-2 bg-white px-3 py-3">
			<section className="w-100">
				<div className="d-flex flex-column">
					<div className="row d-flex align-items-center justify-content-between">
						<div className="col-12">
							<div className="inner-addon right-addon">
								<Select
									options={dataCursos.map((value) => ({
										value: value.id,
										label: `${value.nome}`,
									}))}
									styles={customStyles}
									placeholder="Selecione o curso desejado"
									noOptionsMessage={() => "Nenhum curso encontrado."}
									onChange={handleCursoChange}
									className="curso-selector"
								/>
							</div>
						</div>
					</div>
				</div>
			</section>

			<ModulosView modulos={dataModulosInicio} />
		</div>
	);
};

export default CourseSelector; 